import React, { useMemo } from 'react';
import type { Office } from '../types';
import OfficeBadge from '../shared/office_badge';
import CompanyOfficeSelect from '../shared/company_office_select';

type OfficeSelectorProps = {
  enable: boolean;
  officesById: { [key: number]: Office };
  selectedOfficeIds: number[];
  onChange: (ids: number[]) => void;
}
const OfficeSelector = ({ enable, officesById, selectedOfficeIds, onChange }: OfficeSelectorProps) => {
  const officeOptions : Array<{ value: string; label: string }> = useMemo(() => {
    return Object.keys(officesById).map(officeId => ({
      value: officeId,
      label: officesById[officeId].name,
    })).filter(option => !selectedOfficeIds.includes(parseInt(option.value)));
  }, [officesById, selectedOfficeIds]);

  if (!enable) return null;

  const handleOfficeSelect = ({ value }: { value: string }) => {
    return onChange([...selectedOfficeIds, parseInt(value)]);
  };

  return (
    <div>
      <h5 className="mt-4 mb-3">Offices User Can Manage</h5>
      <div className="mb-3 d-flex gap-2 flex-wrap justify-content-between">
        {selectedOfficeIds.map(officeId => (
          <OfficeBadge
            key={officeId}
            officeName={officesById[officeId].name}
            onClick={() => onChange(selectedOfficeIds.filter(id => id !== officeId))}
          />
        ))}
        <div className="flex-grow-1">
          <CompanyOfficeSelect
            companyOfficeOptions={officeOptions}
            maxWidth={200}
            placeholder=""
            onChange={handleOfficeSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default OfficeSelector;
